import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateParkingServiceMetadata } from '../../api/parking-service.ts';
import { UpdateParkingServiceMetadataRequest } from '../../api/requests/parking-service-request.ts';

export default function useUpdateParkingServiceMetadata(): UseMutationResult<
  Awaited<ReturnType<typeof updateParkingServiceMetadata>>,
  Error,
  UpdateParkingServiceMetadataRequest
> {
  return useMutation({
    mutationFn: updateParkingServiceMetadata,
  });
}
